<template>
  <md-menu class="menu-button" md-direction="bottom-end" mdCloseOnSelect>
    <md-button md-menu-trigger>{{text}} <ChevronDown/></md-button>
    <md-menu-content>
      <slot />
    </md-menu-content>
  </md-menu>
</template>

<script>
import ChevronDown from '../../assets/icons/chevron-down.svg';

export default {
  name: 'MenuButton',
  props: {
    text: String,
  },
  components:{
    ChevronDown,
  },
};
</script>

<style lang="scss">
  .md-menu-content-container .md-list{
    font-family: 'Montserrat', sans-serif;
  }
</style>

<style scoped lang="scss">
.menu-button button{
  min-width: 40px;
  color: #330E2F;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 12px;
  text-transform: none;
}
</style>
